import React from 'react';
import PropTypes from 'prop-types';

const Payouts = ({ altText }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='1.5em' height='1.5em' fill='none'>
      <title id='payouts-title'>{altText}</title>
      <path fill='currentColor' fillRule='evenodd' d='M16 2.25a4.75 4.75 0 1 0 0 9.5 4.75 4.75 0 0 0 0-9.5ZM12.75 7a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0ZM1.25 12.5a2.25 2.25 0 0 1 2.25-2.25h1a2.25 2.25 0 0 1 2.236 2h1.91c.35 0 .694.081 1.006.238l1.367.683a.75.75 0 0 0 .335.079H13.5c.934 0 1.736.57 2.076 1.38l1.537-1.152a2.822 2.822 0 1 1 3.333 4.554l-4.619 3.299a2.25 2.25 0 0 1-1.308.419H9.454a2.25 2.25 0 0 1-1.248-.378l-1.604-1.069A2.25 2.25 0 0 1 4.5 21.75h-1a2.25 2.25 0 0 1-2.25-2.25v-7Zm7.396 1.25H6.75v4.849l2.288 1.525a.75.75 0 0 0 .416.126h5.065a.75.75 0 0 0 .436-.14l4.619-3.299a1.322 1.322 0 1 0-1.562-2.133l-2.54 1.905A2.25 2.25 0 0 1 13.5 17.75H12a.75.75 0 0 1 0-1.5h1.5a.75.75 0 0 0 0-1.5h-2.146a2.25 2.25 0 0 1-1.006-.238L8.98 13.83a.75.75 0 0 0-.335-.079Zm-4.146-2a.75.75 0 0 1 .75.75v7a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-7a.75.75 0 0 1 .75-.75h1Z' clipRule='evenodd'/>
    </svg>
  );
};

Payouts.propTypes = {
  altText: PropTypes.string
};

export default Payouts;
